import { Component } from '@angular/core';

@Component({
  selector: 'fl-inline-error-box',
  templateUrl: './inline-error-box.component.html',
})
export class InlineErrorBoxComponent {}
